import * as RadixTooltip from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';

export const TooltipProvider = RadixTooltip.Provider;

interface TooltipProps {
  label: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

/** 所有圖示按鈕都必須有可讀名稱與 tooltip（spec 25.1）。 */
export function Tooltip({ label, children, side = 'bottom' }: TooltipProps) {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          sideOffset={8}
          className="z-[60] max-w-64 rounded-[var(--radius-control)] border border-border bg-surface-raised px-3 py-1.5 text-[0.8125rem] text-text shadow-[var(--shadow-raised)] select-none"
        >
          {label}
          <RadixTooltip.Arrow className="fill-[var(--surface-raised)]" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
